module.exports = " <div v-el:qi-niu-container> <div class=\"btn btn-default\" v-el:qi-niu-button> <i class=\"glyphicon glyphicon-plus\"></i> <template v-if=\"options.uptype == 'wenjian'\"> <span>上传文件</span> </template> <template v-else> <span>上传图片</span> </template> </div> <template v-if=\"options.uptype == 'wenjian'\"> <small>(请上传文件)</small> </template> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/qiniu.vue
// module id = 51
// module chunks = 1 3